export const SUPPORT_ADMIN_RELOAD_DELAY_MS = 500
